import { Navigate, Outlet } from "react-router-dom"

const GuestRoutes = () => {
  const user = localStorage.getItem("user")

  return user ? <Navigate to="/" /> : <Outlet />
}

export default GuestRoutes
